import { SERVICES, DOCTORS, TESTIMONIALS, BLOGS } from "./data";

export const getServices = () => Promise.resolve(SERVICES);
export const getService = (slug) => {
  const service = SERVICES.find((s) => s.slug === slug);
  return service ? Promise.resolve(service) : Promise.reject(new Error("Service not found"));
};

export const getDoctors = (department) => {
  if (department) {
    return Promise.resolve(DOCTORS.filter((d) => d.department_slug === department));
  }
  return Promise.resolve(DOCTORS);
};

export const getDoctor = (id) => {
  const doc = DOCTORS.find((d) => d.id === id);
  return doc ? Promise.resolve(doc) : Promise.reject(new Error("Doctor not found"));
};

export const getTestimonials = () => Promise.resolve(TESTIMONIALS);

export const getBlogs = () => Promise.resolve(BLOGS);
export const getBlog = (slug) => {
  const blog = BLOGS.find((b) => b.slug === slug);
  return blog ? Promise.resolve(blog) : Promise.reject(new Error("Blog not found"));
};

// Mock the post endpoints so the UI doesn't crash
export const createAppointment = (data) => Promise.resolve({ ...data, id: "mock-id", status: "success" });
export const createContact = (data) => Promise.resolve({ ...data, id: "mock-id", status: "success" });
